<div class="cost-chart">
    @for (item of chartData; track item.status.value) {
    @if (item.status.value != 'UnknownStatus' || item.value != 0) {
    <div [id]="'scheduling-chart-item-' + item.status.value"
        class="chart-item"
        (click)="selectSchedulingStatus(item.status.value)">
        <div class="chart-item__container"
            [ngClass]="{ 'selected': selectedSchedulingStatus === item.status.value}">
            <div class="chart-item--value">
                {{ item.value || 0}}
            </div>
            <div class="chart-item--bar">
                <div>{{ 'task.schedulingStatus.' + item.status.value | blah }}</div>
                <div class="color-bar"
                    [ngClass]="item.status.value"
                    [style.width.%]="item.value == 0 ? 0 : item.value / maxValue * 100">
                </div>
            </div>
        </div>
    </div>
    }
    }
</div>